import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import Icon from "@mui/material/Icon"

import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";



import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import PageTitle from "components/PageTitle";

import * as ajax from "helpers/ajax";
import styles from "./index.module.css";
import html2pdf from 'html2pdf.js'
import CalendarIcon from 'components/CalendarIcon'
import { PATH } from "../../constant";
import CircularProgress from '@mui/material/CircularProgress';
import ReactMarkdown from 'react-markdown'
import rehypeRaw from "rehype-raw";
import { IFrame } from '../../iframe'
import Highlighter from "react-highlight-words";
import MDInput from "../../components/MDInput";


const monthNames = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
    "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

const weekNames = ["D", "L", "M", "M", "G", "V", "S"]



export default class Report extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            noteData: [],
            operaiData: [],
            operaiOfTheDay: [],

            loading: false,

            selectedDay: new Date(),
            searchText: "",
        };
        this.fetchController = new AbortController();
        this.fetchSignal = this.fetchController.signal;
        this.csv = [[]];

        

    }


    componentDidMount = () => {
        this.load()
    }

    load = () => {
        this.setState({ loading: true });
        this.setState({data:[]},this.downloadData)
    }

    downloadData = () => {
        //ajax.ajaxGetStrapi("commessa-notes?populate=*&filters[data]=" + this.convertDate(this.state.selectedDay), this.loadCallback)
        this.csv = [[]];
        fetch(PATH + "commessa-notes?populate=*&filters[data]=" + this.convertDate(this.state.selectedDay), {
            method: "GET",
            signal: this.fetchSignal,
            headers: {
                Authorization: `Bearer ${global.jwt}`,
            },
        })
            .then((response) => response.json())
            .then((responseJson) => {
                this.loadCallback(responseJson)
            })
            .catch((error) => {
                console.log(error);
                //Catch Service Error
            });

        fetch(PATH + "mezzi-notes?populate=*&filters[data]=" + this.convertDate(this.state.selectedDay), {
            method: "GET",
            headers: {
                Authorization: `Bearer ${global.jwt}`,
            },
        })
            .then((response) => response.json())
            .then((responseJson) => {
                this.loadNoteCallback(responseJson)
            })
            .catch((error) => {
                console.log(error);
                //Catch Service Error
            });

        fetch(PATH + "operai-mezzis?populate=*&filters[data]=" + this.convertDate(this.state.selectedDay), {
            method: "GET",
            headers: {
                Authorization: `Bearer ${global.jwt}`,
            },
        })
            .then((response) => response.json())
            .then((responseJson) => {
                this.loadOperaiMezziCallback(responseJson)
            })
            .catch((error) => {
                console.log(error);
                //Catch Service Error
            });

    }

    loadCallback = (response) => {
        let data = this.state.data;

        if (response.data.length <= 0) {
            this.checkOperai();
        }

        response.data.map((el, index) => {
            if (!el.commessa) {
                return;
            }
            
            ajax.ajaxGetStrapi("operai-commesses?populate=*&filters[commessa][id]=" + el.commessa.id + "&filters[data]=" + this.convertDate(this.state.selectedDay), (workerResponse) => {
                let temp = {}
                temp.commessa = el.commessa.nome
                temp.note = el.note
                temp.note_altre_imprese = el.note_altre_imprese
                temp.note_verifiche = el.note_verifiche
                temp.note_trasposrti = el.note_trasposrti
                temp.workers = [];

                workerResponse.data.map((worker) => {
                    if (!worker.operaio) {
                        return;
                    }
                    temp.workers.push(worker.operaio.nome + " " + worker.operaio.cognome)
                })

                temp.workers = [...new Set(temp.workers)];

                data.push(temp)
                this.setState({ data: data }, this.checkOperai)
            })
        })
        this.setState({ loading: false });

    }

    loadNoteCallback = (response) => {
        this.setState({ noteData: response.data })
    }

    loadOperaiMezziCallback = (response) => {
        this.setState({ operaiData: response.data })
    }

    checkOperai = () => {
        fetch(PATH + "operai-commesses?populate=*&filters[data]=" + this.convertDate(this.state.selectedDay), {
            method: "GET",
            headers: {
                Authorization: `Bearer ${global.jwt}`,
            },
        })
            .then((response) => response.json())
            .then((responseJson) => {
                this.checkOperaiCallback(responseJson)
            })
            .catch((error) => {
                console.log(error);
                //Catch Service Error
            });
    }

    checkOperaiCallback = (response) => {
        let note = this.state.data;

        response.data.map((operaio) => {
            if (!operaio.commessa || !operaio.operaio) {
                return;
            }
            
            let found = false;
            for (let i = 0; i < note.length; i++) {
                if (note[i].commessa == operaio.commessa.nome) {
                    found = true;
                    if (!note[i].workers.includes(operaio.operaio.nome + " " + operaio.operaio.cognome)) {
                        note[i].workers.push(operaio.operaio.nome + " " + operaio.operaio.cognome)
                    } 
                }
            }
            if (!found) {
                let temp = {}
                temp.commessa = operaio.commessa.nome
                temp.note = ""
                temp.note_altre_imprese = ""
                temp.note_verifiche = ""
                temp.note_trasposrti = ""
                temp.workers = [];
                temp.workers.push(operaio.operaio.nome + " " + operaio.operaio.cognome)

                note.push(temp)

            }
        })
        
        // Rimuovi duplicati basandosi sul nome della commessa
        const uniqueNotes = [];
        const commessaNames = new Set();
        
        note.forEach((item) => {
            if (!commessaNames.has(item.commessa)) {
                commessaNames.add(item.commessa);
                uniqueNotes.push(item);
            } else {
                // Se esiste già, unisci i workers
                const existing = uniqueNotes.find(n => n.commessa === item.commessa);
                if (existing) {
                    existing.workers = [...new Set([...existing.workers, ...item.workers])];
                    // Usa la nota non vuota se c'è
                    if (!existing.note && item.note) existing.note = item.note;
                    if (!existing.note_altre_imprese && item.note_altre_imprese) existing.note_altre_imprese = item.note_altre_imprese;
                    if (!existing.note_verifiche && item.note_verifiche) existing.note_verifiche = item.note_verifiche;
                    if (!existing.note_trasposrti && item.note_trasposrti) existing.note_trasposrti = item.note_trasposrti;
                }
            }
        });
        
        this.setState({ data: uniqueNotes })

    }

    resetCSV = () => {
        this.csv = [[]];

    }
    convertDate = (date) => {
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }

    changeMonth = (n) => {
        let date = this.state.selectedDay
        date.setDate(date.getDate() + n);

        this.fetchController.abort();
        this.fetchController = new AbortController();
        this.fetchSignal = this.fetchController.signal;

        this.setState({ selectedDay: date }, this.load)
    }

    setDate = (val) => {
        let date = new Date(val)

        this.fetchController.abort();
        this.fetchController = new AbortController();
        this.fetchSignal = this.fetchController.signal;

        this.setState({ selectedDay: date }, this.load)
    }

    renderCalendar = () => {
        return (
            <>
                <Grid container justifyContent={"space-between"} alignItems={"center"} >
                    <Grid item>
                        <MDButton variant="text" color="dark" onClick={() => this.changeMonth(-1)}><Icon>keyboard_double_arrow_left</Icon></MDButton>
                    </Grid>
                    <Grid item>
                        <MDTypography variant={"h3"} mr={2}>
                            <CalendarIcon onChange={(val) => this.setDate(val)} style={{ verticalAlign:"middle" }} />
                            {this.state.selectedDay.getDate() + " " + monthNames[this.state.selectedDay.getMonth()] + " " + this.state.selectedDay.getFullYear()}
                        </MDTypography>
                    </Grid>
                    <Grid item>
                        <MDButton variant="text" color="dark" onClick={() => this.changeMonth(1)}><Icon>keyboard_double_arrow_right</Icon></MDButton>
                    </Grid>
                </Grid>
            </>
        );
    }

    highlightText = (text, searchText) => {
        if (!searchText || !text) return text;
        
        // Escape special regex characters
        const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        
        // Create a regex to find the search text, case insensitive
        // Use a negative lookahead to avoid matching text inside HTML tags
        const regex = new RegExp(`(${escapeRegex(searchText)})(?![^<]*>)`, 'gi');
        
        // Replace matches with marked version
        return text.replace(regex, '<mark style="background-color: yellow; font-weight: inherit; color: inherit;">$1</mark>');
    }

    renderTable = (data, index) => {
        return (
            <table key={"table-" + index} className={[styles.table, index==0?"":"page-break"].join(' ')}>
                <thead>
                    <tr>
                        <td colSpan="2">
                            <MDTypography variant={"h3"} textTransform="uppercase">
                                <Highlighter
                                    searchWords={[this.state.searchText]}
                                    autoEscape={true}
                                    textToHighlight={data.commessa}
                                />
                            </MDTypography>
                            {this.csvAdd((index * 5) + 1, data.commessa)}
                        </td>
                    </tr>  
                </thead>
                <tbody>
                    <tr>
                        <td width="50%" style={{ padding: 10 }}>
                            {this.csvAdd((index * 5) + 2, "")}
                            {data.workers.map((el, j) => {
                                { this.csv[index * 5 + 2][0] = this.csv[index * 5 + 2][0] + el + "\n" }

                                return (
                                    <>
                                        <MDTypography key={index + "-" + j} variant={"caption"} textTransform="uppercase">
                                            <Highlighter
                                                searchWords={[this.state.searchText]}
                                                autoEscape={true}
                                                textToHighlight={el}
                                            />
                                        </MDTypography>
                                        <br />
                                    </>
                                )
                            })}
                        </td>
                        <td style={{ padding: 10 }}>
                            <MDTypography variant={"caption"} style={{ whiteSpace: "pre-wrap" }}>
                                <ReactMarkdown
                                    rehypePlugins={[rehypeRaw]}
                                    children={this.highlightText(data.note, this.state.searchText)}
                                />

                                {this.csvAdd((index * 5) + 2, data.note)}
                            </MDTypography>
                        </td>
                    </tr>
                    <tr>
                        <td width="50%" style={{ padding: 10 }}>
                            <MDTypography variant={"caption"} textTransform="uppercase">
                                <Highlighter
                                    searchWords={[this.state.searchText]}
                                    autoEscape={true}
                                    textToHighlight={"Trasporti"}
                                />

                               </MDTypography>
                            {this.csvAdd((index * 5) + 3, "Trasporti")}

                        </td>
                        <td style={{ padding: 10 }}>
                            <MDTypography variant={"caption"} style={{ whiteSpace: "pre-wrap" }}>
                                <ReactMarkdown
                                    rehypePlugins={[rehypeRaw]}
                                    children={this.highlightText(data.note_trasposrti, this.state.searchText)}
                                />

                                {this.csvAdd((index * 5) + 3, data.note_trasposrti)}

                            </MDTypography>
                        </td>
                    </tr>
                    <tr>
                        <td width="50%" style={{ padding: 10 }}>
                            <MDTypography variant={"caption"} textTransform="uppercase">
                                <Highlighter
                                    searchWords={[this.state.searchText]}
                                    autoEscape={true}
                                    textToHighlight={"Verifiche"}
                                />

                            </MDTypography>
                            {this.csvAdd((index * 5) + 4, "Verifiche")}

                        </td>
                        <td style={{ padding: 10 }}>
                            <MDTypography variant={"caption"}  style={{ whiteSpace: "pre-wrap" }}>
                                <ReactMarkdown
                                    rehypePlugins={[rehypeRaw]}
                                    children={this.highlightText(data.note_verifiche, this.state.searchText)}
                                />
                                {this.csvAdd((index * 5) + 4, data.note_verifiche)}

                            </MDTypography>
                        </td>
                    </tr>
                    <tr>
                        <td width="50%" style={{ padding: 10 }}>
                            <MDTypography variant={"caption"} textTransform="uppercase">
                                <Highlighter
                                    searchWords={[this.state.searchText]}
                                    autoEscape={true}
                                    textToHighlight={"Altre imprese"}
                                />
                                </MDTypography>
                            {this.csvAdd((index * 5) + 5, "Altre imprese")}

                        </td>
                        <td style={{ padding: 10 }}>
                            <MDTypography variant={"caption"} style={{ whiteSpace: "pre-wrap" }}>
                                <ReactMarkdown
                                    rehypePlugins={[rehypeRaw]}
                                    children={this.highlightText(data.note_altre_imprese, this.state.searchText)}
                                />
                                {this.csvAdd((index * 5) + 5, data.note_altre_imprese)}

                            </MDTypography>
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }

    createNoteOperaiData = () => {
        let mezzi=[]

        this.state.noteData.map((el) => {
            if (el.mezzo) {
                mezzi.push(el.mezzo)
            }
        })
        this.state.operaiData.map((el) => {
            if (el.mezzo) {
                mezzi.push(el.mezzo)
            }
        })

        mezzi = [...new Map(mezzi.map(item => [item['id'], item])).values()];

        let returnObject = [];
        mezzi.map((mezzo) => {
            let temp = {};
            temp.mezzo = mezzo;
            temp.note = [];
            temp.operai = [];

            this.state.noteData.map((el) => {
                if (el.mezzo) {
                    if (el.mezzo.id == mezzo.id) {
                        temp.note.push(el.note);
                    }
                }
            })

            this.state.operaiData.map((el) => {
                if (el.mezzo && el.operaio) {
                    if (el.mezzo.id == mezzo.id) {
                        temp.operai.push(el.operaio);
                    }
                }
            })

            returnObject.push(temp);
        })

       return returnObject;
    }

    renderNote = () => {

        let data = this.createNoteOperaiData();
        if (data.length <= 0) { return null }

        let csvIndex = this.state.data.length * 6;

        return (
            <table key={"table-mezzi"} className={[styles.table, "page-break"].join(' ')} >
                <thead>
                    <tr>
                        <td colSpan="2">
                            <MDTypography variant={"h3"} textTransform="uppercase">
                                <Highlighter
                                    searchWords={[this.state.searchText]}
                                    autoEscape={true}
                                    textToHighlight={"Mezzi Utilizzati"}
                                />
                            </MDTypography>
                            {this.csvAdd(csvIndex + 1, "Mezzi Utilizzati")}
                        </td>
                    </tr>
                </thead>
                <tbody>
                    {data.map((el, index) => {
                        return (
                            <tr key={"row-mezzo-" + index}>
                                <td width="50%" style={{ padding: 10 }}>
                                    <MDTypography variant={"caption"} style={{ whiteSpace: "pre-wrap" }}>

                                        {this.csvAdd(csvIndex + 2 + index, "")}
                                        {el.operai.map((operaio, opIndex) => {
                                            if (!operaio) {
                                                return null;
                                            }
                                            const nomeCompleto = (operaio.nome || '') + " " + (operaio.cognome || '');
                                            this.csv[csvIndex + 2 + index][0] = this.csv[csvIndex + 2 + index][0] + nomeCompleto + "\n"
                                            return (
                                                <p key={`operaio-${index}-${opIndex}`}>
                                                    <Highlighter
                                                        searchWords={[this.state.searchText]}
                                                        autoEscape={true}
                                                        textToHighlight={nomeCompleto}
                                                    />
                                                </p>
                                            )
                                        })}

                                    </MDTypography>
                                </td>
                                <td>
                                    <MDTypography variant={"caption"} style={{ whiteSpace: "pre-wrap" }}>
                                        {(() => {
                                            const mezzoText = (el.mezzo?.marca || '') + " " + (el.mezzo?.targa || '') + " " + (el.mezzo?.noleggio ? "Noleggio" : "");
                                            this.csvAdd(csvIndex + 2 + index, mezzoText);
                                            return mezzoText;
                                        })()}
                                        <Highlighter
                                            searchWords={[this.state.searchText]}
                                            autoEscape={true}
                                            textToHighlight={(el.mezzo?.marca || '') + " " + (el.mezzo?.targa || '') + " " + (el.mezzo?.noleggio ? "Noleggio" : "")}
                                        />
                                        {el.note.map((nota, notaIndex) => {
                                            this.csv[csvIndex + 2 + index][1] = this.csv[csvIndex + 2 + index][1] + "\n" + nota
                                            return (
                                                <p key={`nota-${index}-${notaIndex}`}>
                                                    <Highlighter
                                                        searchWords={[this.state.searchText]}
                                                        autoEscape={true}
                                                        textToHighlight={nota}
                                                    />
                                                </p>
                                            )
                                        })}

                                    </MDTypography>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )

    }


    print = () => {
        //window.print();
        window.frames["printf"].focus();
        window.frames["printf"].print();
    }



    download = () => {
        document.getElementById("print-pdf-date").classList.remove("onlyPrint");

        setTimeout(() => {
            var element = document.getElementById('print-table').innerHTML;
            var opt = {
                margin: 1,
                filename: "report " + this.state.selectedDay.getDate() + " " + monthNames[this.state.selectedDay.getMonth()] + " " + this.state.selectedDay.getFullYear() + ".pdf",
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
            };
            html2pdf(element, opt).then(() => {
                document.getElementById("print-pdf-date").classList.add("onlyPrint");
            });

        },
            100
        );



    }

    csvAdd = (i, v) => {
        if (!this.csv[i]) { this.csv[i] = [] }
        if (v == null) { v = "" }
        this.csv[i].push(v)
    }

    downloadCSVFile = () => {
        var output = "";
        this.csv.forEach((o, i) => {
            o.forEach((p, j) => {
                output += `"${p}"`;
                if (j < o.length - 1) {
                    output += ",";
                }
            });
            output += "\n";
        });
        let csvData = output;
        let a: any = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        let blob = new Blob([csvData], { type: 'text/csv' });
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = 'report_attivita.csv';
        a.click();

        return output;

    }


    render() {

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"Report " + this.state.selectedDay.getDate()+" " + monthNames[this.state.selectedDay.getMonth()] + " " + this.state.selectedDay.getFullYear()}
                    subtitle={""}
                    backButton={this.props.backFunction}
                    menu={[{ label: "Stampa", function: this.print }, { label: "Scarica PDF", function: this.download }, { label: "Scarica CSV", function: this.downloadCSVFile }]}
                />

                <MDBox sx={{ backgroundColor: "white!important" }} p={3} borderRadius="lg" shadow="lg" >
                    {this.renderCalendar()}
                    <div style={{textAlign:"right"}}>
                    <MDInput
                        placeholder={"Cerca"}
                        value={this.state.searchText}
                        onChange={(e) => this.setState({ searchText: e.target.value })}
                    />
                    </div>
                    {this.state.loading ?
                        <div style={{ textAlign: "center", marginTop: 15 }}><CircularProgress /></div>
                        :
                        <>
                            <IFrame id="printf" name="printf" >
                                <MDTypography className={"onlyPrint"} variant={"h3"}>{this.state.selectedDay.getDate() + " " + monthNames[this.state.selectedDay.getMonth()] + " " + this.state.selectedDay.getFullYear()}</MDTypography>
                                {this.state.data.map((el, index) => {
                                    return this.renderTable(el, index)
                                })}
                                {this.renderNote()}
                            </IFrame>

                            <div id="print-table" className={styles.print}>
                                <MDTypography id="print-pdf-date" className={"onlyPrint"} variant={"h3"}>{this.state.selectedDay.getDate() + " " + monthNames[this.state.selectedDay.getMonth()] + " " + this.state.selectedDay.getFullYear()}</MDTypography>
                                {this.resetCSV()}
                                {this.csvAdd(0, this.state.selectedDay.getDate() + " " + monthNames[this.state.selectedDay.getMonth()] + " " + this.state.selectedDay.getFullYear())}
                                {this.state.data.map((el, index) => {
                                    return this.renderTable(el, index)
                                })}
                                {this.renderNote()}
                            </div>
                        </>
                    }
                </MDBox>

            </DashboardLayout>
        )
    }
}


